// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import 'babel-polyfill'
import Vue from 'vue'
import Element from 'element-ui'
// import 'element-ui/lib/theme-chalk/index.css'
import App from './App'
import router from './router'
import store from './store'
import browser from 'browser-detect'
import {addCloudEyeTrack} from '@/libs/cloudEye'

Vue.config.productionTip = false

Vue.use(Element)

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  template: '<App/>',
  components: { App },
  created() {
    addCloudEyeTrack()
  },
  mounted () {
    // 初始化应用数据
    this.$store.dispatch('initAppInfo')
    // 检测浏览器
    this.detectBrowser()
  },
  methods: {
    detectBrowser() {
      let browserInfo = browser()
      if (browserInfo.name !== 'chrome') {
        document.getElementById('browserAdvice').style.display = 'block'
      }
    }
  }
})



// WEBPACK FOOTER //
// ./src/main.js